module.exports = __webpack_public_path__ + "img/hk.0ba81c85.png";